import { createRouter, createWebHashHistory } from 'vue-router';
import Dashboard from './components/Dashboard.vue';
import AppCentral from './App.vue';

const routes = [
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
    },
    {
        path: '/AppCentral',
        name: 'AppCentral',
        component: AppCentral,
    },
    {
        path: '/formLogin',
        name: 'formLogin',
        component: () => import('./FormLogin.vue'),
    },
    {
        path: '/formDatosP',
        name: 'formDatosP',
        component: () => import('./components/FormDatosP.vue'),
    },
    {
        path: '/formGradosAcad',
        name: 'formGradosAcad',
        component: () => import('./components/FormGradosAcad.vue'),
    },
    {
        path: '/formExperAcad',
        name: 'formExperAcad',
        component: () => import('./components/FormExperAcad.vue'),
    },
    {
        path: '/formActDocente',
        name: 'formActDocente',
        component: () => import('./components/FormActividadDoc.vue'),
    },
    {
        path: '/formProductosA',
        name: 'formProductosA',
        component: () => import('./components/FormProductos.vue'),
    },
    {
        path: '/formExperProf',
        name: 'formExperProf',
        component: () => import('./components/FormExperProf.vue'),
    },
    {
        path: '/formAsoc',
        name: 'formAsoc',
        component: () => import('./components/FormAsoc.vue'),
    },
    {
        path: '/formPremios',
        name: 'formPremios',
        component: () => import('./components/FormPremios.vue'),
    },
    {
        path: '/formLogros',
        name: 'formLogros',
        component: () => import('./components/FormLogros.vue'),
    },
    {
        path: '/formLibrosPublicados',
        name: 'formLibrosPublicados',
        component: () => import('./components/FormLibrosPublicados.vue'),
    },
    {
        path: '/formMaterialDidac',
        name: 'formMaterialDidac',
        component: () => import('./components/FormMaterialDidac.vue'),
    },
    {
        path: '/formCVDocente',
        name: 'formCVDocente',
        component: () => import('./components/CVDocente.vue'),
    },    
    {
        path: '/formUsuariosAdmin',
        name: 'formUsuariosAdmin',
        component: () => import('./components/FormUsuariosAdmin.vue'),
    },    
    {
        path: '/formDocentesAdmin',
        name: 'formDocentesAdmin',
        component: () => import('./components/FormDocentesAdmin.vue'),
    },    
    {
        path: '/formReporte',
        name: 'formReporte',
        component: () => import('./components/FormReporte.vue'),
    },    
    {
        path: '/formCreditos',
        name: 'formCreditos',
        component: () => import('./components/FormCreditos.vue'),
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
